import { Box, Skeleton } from "@mui/material";
import "../../styles/material.css";
import { isBrowser } from "react-device-detect";

export const ChatHeaderSkeleton = () => {
  return (
    <Box className={`headerContainer mdc-typography--border-bottom ${!isBrowser ? "bg-true-white" : "bg-platinum"}`}>
      <Skeleton variant="circular" width={36} height={36} />
      <Skeleton className="mar-l-16 mar-r-16 flex-grow" variant="rounded" height={24} />
      <Skeleton variant="circular" width={36} height={36} />
    </Box>
  );
};

export const ChatFooterSkeleton = () => {
  return (
    <Box className={`chatFooter mdc-typography--border-bottom bg-true-white pos-abs mdc-typography--border-top pad-t-8 pad-b-8`} sx={{ bottom: 0 }}>
      <Skeleton className="mar-l-16 mar-r-16 flex-grow" variant="rounded" height={48} />
      <Skeleton className="mar-b-8 mar-r-16" variant="circular" width={36} height={36} />
    </Box>
  );
};

const ChatSkeleton = ({ chatAreaHeight }: any) => {
  return (
    <Box className="w-per-100 display-flex flex-direction-column mar-t-64 pad-16 bg-true-white flex-grow">
      <Box className="w-per-100 flex-direction-column display-flex display-flex-center">
        <Skeleton variant="circular" width={80} height={80} />
        <Skeleton className="mar-t-12" variant="rounded" width={160} height={24} />
        <Skeleton className="mar-t-4" variant="rounded" width={240} height={24} />
      </Box>
      <Box className={`mar-t-12 w-per-100 display-flex-justify-center`}>
        <Skeleton variant="rounded" width={32} height={18} />
      </Box>
      {Array.from({ length: Math.floor((window.innerHeight - chatAreaHeight - 64) / 56) }).map((k: any, i: number) => {
        return i % 2 === 0 ? (
          <Box key={i} className={`mar-t-16`} sx={{ width: "70%", alignSelf: "flex-end" }}>
            <Skeleton variant="rounded" height={40} />
          </Box>
        ) : (
          <Box key={i} className={`mar-t-16 flex-direction-row display-flex`} sx={{ width: "70%", alignSelf: "flex-start" }}>
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton className="mar-l-8" variant="rounded" width="calc(100% - 48px)" height={40} />
          </Box>
        );
      })}
    </Box>
  );
};

export default ChatSkeleton;
